/* eslint dom-in-jsx/no-document-calls: 0 */
/* eslint dom-in-jsx/no-jquery-in-jsx: 0 */
import React, { Component } from 'react';
import moment from 'moment-timezone';
import _ from 'underscore';
import Select from 'react-select';
// eslint-disable-next-line import/no-named-as-default
import styled from 'styled-components';

const StyledSelect = styled(Select)`
  margin-bottom: 10px;
`;

const P = styled.p`
  margin-bottom: 3px;
`;

const format = 'dddd, MMMM Do YYYY, h:mm:ss a z';

export default class DateTime extends Component {
  constructor(props) {
    let time = props.includeSeconds ? '00:00:00' : '00:00';

    super(props);
    this.state = {
      value: this.props.value,
      date: '',
      time: time,
      timezone: _.first(this.timezones()),
      input_value: '',
    };
    this.date_id = _.uniqueId('date_');
    this.time_id = _.uniqueId('time_');
  }

  componentDidMount() {
    let format = this.props.includeSeconds ? 'HH:mm:ss' : 'HH:mm';

    if (!_.isEmpty(this.props.value)) {
      this.persist({
        date: moment(this.props.value).format('YYYY-MM-DD'),
        time: moment(this.props.value).format(format),
      });
    }

    if (this.props.disableListener) {
      return;
    }

    $(`#${this.date_id}`).on('change', (e) =>
      this.persist({ date: e.target.value }),
    );
    $(`#${this.time_id}`).on('change', (e) =>
      this.persist({ time: e.target.value }),
    );
  }

  persist(data) {
    let date = _.has(data, 'date') ? data.date : this.state.date,
      timezone = _.has(data, 'timezone') ? data.timezone : this.state.timezone;

    data.input_value = _.isEmpty(date)
      ? ''
      : this.shift(this.buildMoment(data), timezone);
    this.setState(data);
  }

  timezones() {
    return _.uniq(
      this.props.zones.map((z) => (z === 'user' ? moment.tz.guess() : z)),
    );
  }

  shift(date, timezone = this.state.timezone) {
    let another = date.clone();

    another.tz(timezone);
    another.add(
      date.tz(this.state.timezone).utcOffset() - another.utcOffset(),
      'minutes',
    );

    return another.format();
  }

  buildMoment(data = {}) {
    let valueDate = moment(),
      date = _.has(data, 'date') ? data.date : this.state.date,
      time = _.has(data, 'time') ? data.time : this.state.time,
      defaultTime = this.props.includeSeconds ? '00:00:00' : '00:00';

    if (!_.isEmpty(date)) {
      valueDate = this.setDate(valueDate, date);
    }
    valueDate = this.setTime(valueDate, _.isEmpty(time) ? defaultTime : time);

    return valueDate;
  }

  setDate(dateObject = this.buildMoment(), date = this.state.date) {
    let [year, month, day] = date.split('-');

    dateObject.set({ year: year, month: parseInt(month, 10) - 1, date: day });
    return dateObject;
  }

  setTime(dateObject = this.buildMoment(), time = this.state.time) {
    let [hour, minute, second] = time.split(':');

    if (!this.props.includeSeconds) {
      second = '00';
    }
    dateObject.set({ hour: hour, minute: minute, second: second });
    return dateObject;
  }

  getOptions() {
    return this.timezones().map((item, i) => {
      return { label: this.props.labels[i], value: item };
    });
  }

  conditionalProps() {
    return this.props.includeSeconds ? { step: 1 } : {};
  }

  render() {
    return (
      <div
        className={
          _.isEmpty(this.props.error)
            ? 'DateTimeContainer'
            : 'DateTimeContainer field_with_errors'
        }
      >
        <input
          name={this.props.name}
          type='hidden'
          value={this.state.input_value}
        />
        <div
          className={`DateTimeReadable ${this.props.readonly ? '' : 'show-disabled'}`}
        >
          <If condition={_.isEmpty(this.state.value)}>None</If>
          <If condition={!_.isEmpty(this.state.value)}>
            <If condition={this.props.displayAll}>
              {this.timezones().map((t, index) => {
                return (
                  <P key={index}>
                    {moment(this.state.value).tz(t).format(format)} (
                    {this.props.labels[index]})
                  </P>
                );
              })}
            </If>
            <If condition={!this.props.displayAll}>
              {moment(this.state.value).tz(moment.tz.guess()).format(format)}{' '}
              (Local Time)
            </If>
          </If>
        </div>
        <If condition={!this.props.readonly}>
          <div className='DateTimeInputs hide-disabled'>
            <div className='DateInput half-width left'>
              <input
                className=''
                id={this.date_id}
                required={this.props.required}
                type='date'
                value={this.state.date}
                onChange={(e) => this.persist({ date: e.target.value })}
              />
            </div>
            <div className='TimeInput half-width right'>
              <input
                className=''
                id={this.time_id}
                required={this.props.required}
                type='time'
                value={this.state.time}
                onChange={(e) => this.persist({ time: e.target.value })}
                {...this.conditionalProps()}
              />
            </div>
          </div>
          <If condition={!_.isEmpty(this.props.error)}>
            <small className='error'>{this.props.error}</small>
          </If>
          <If condition={this.props.zones.length > 1}>
            <StyledSelect
              className='hide-disabled'
              crealabre='false'
              options={this.getOptions()}
              value={this.state.timezone}
              onChange={(object) => this.persist({ timezone: object.value })}
            />
          </If>
          <p className='hide-disabled'>
            <strong>Timezone:</strong> {this.state.timezone} (
            {moment.tz(this.state.timezone).format('z')})
          </p>
        </If>
      </div>
    );
  }
}
